import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const navItems = [
  { to: '/', label: 'Dashboard', icon: '📊', exact: true },
  { to: '/orcamentos', label: 'Orçamentos', icon: '📋', exact: false },
  { to: '/clientes', label: 'Clientes', icon: '👥', exact: false },
];

const adminItems = [
  { to: '/tipos-persiana', label: 'Tipos', icon: '📂', exact: false },
  { to: '/produtos', label: 'Produtos', icon: '🪟', exact: false },
  { to: '/usuarios', label: 'Usuários', icon: '👤', exact: false },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  function handleLogout() {
    logout();
    navigate('/login');
  }

  const allItems = user?.role === 'ADMIN' ? [...navItems, ...adminItems] : navItems;

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="bg-primary-700 text-white shadow-md sticky top-0 z-50">
        <div className="flex items-center justify-between px-4 py-3">
          <div className="flex items-center gap-2">
            <button onClick={() => setMenuOpen(!menuOpen)} className="md:hidden p-1 rounded">
              <span className="text-xl">☰</span>
            </button>
            <span className="font-bold text-lg">🌴 Palmeira Persianas</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm hidden sm:block">{user?.nome}</span>
            <button onClick={handleLogout} className="text-sm bg-primary-800 px-3 py-1 rounded-lg hover:bg-primary-900">
              Sair
            </button>
          </div>
        </div>
      </header>

      <div className="flex flex-1">
        {/* Sidebar desktop */}
        <nav className="hidden md:flex flex-col w-56 bg-white border-r border-gray-200 py-4 gap-1">
          {allItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.exact}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 text-sm font-medium transition-colors ${
                  isActive ? 'bg-primary-50 text-primary-700 border-r-2 border-primary-600' : 'text-gray-600 hover:bg-gray-50'
                }`
              }
            >
              <span>{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>

        {/* Mobile menu */}
        {menuOpen && (
          <div className="fixed inset-0 z-40 md:hidden" onClick={() => setMenuOpen(false)}>
            <div className="absolute inset-0 bg-black/40" />
            <nav className="absolute top-0 left-0 w-64 h-full bg-white shadow-xl py-4 flex flex-col gap-1 pt-16">
              {allItems.map(item => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.exact}
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-3 text-sm font-medium ${
                      isActive ? 'bg-primary-50 text-primary-700' : 'text-gray-600'
                    }`
                  }
                >
                  <span>{item.icon}</span>
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        )}

        {/* Content */}
        <main className="flex-1 p-4 md:p-6 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
